import { Flex, Text } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import Tooltip from "@components/Tooltip";
import UTMLink from "@components/UTMLink";

const Stats = ({
  label,
  value,
  tooltipText,
  url,
}: {
  label: string;
  value: string;
  tooltipText?: string;
  url?: string;
}) => {
  return (
    <Flex direction={"column"} gap="8px">
      <Flex gap="4px" alignItems="center">
        <Text fontSize={"12px"} fontWeight={"600"} lineHeight={"14.4px"}>
          {label}
        </Text>
        {tooltipText && (
          <Tooltip
            placement="top"
            label={
              <Text fontWeight="400" fontSize="12px">
                {tooltipText}
              </Text>
            }
          />
        )}
      </Flex>
      {url ? (
        <UTMLink href={url} isExternal display="flex" gap="0.5rem">
          <Text fontSize={"24px"} fontWeight={"400"} lineHeight={"28.8px"}>
            {value}
          </Text>
          <BaseImage
            src="/assets/external-link.svg"
            width={10}
            height={5}
            alt="nexus"
          />
        </UTMLink>
      ) : (
        <Text fontSize={"24px"} fontWeight={"400"} lineHeight={"28.8px"}>
          {value}
        </Text>
      )}
    </Flex>
  );
};

export default Stats;
